<template>
  
  <div v-if="visible" class="ui active inverted dimmer">
    <div class="ui loader"></div>
  </div>

</template>

<script>
  export default {
    props: ["visible"], 
  }
</script>

